module.exports = __webpack_public_path__ + "static/media/sykkel_brown-min.132ae540.png";